<template>
    <div class="footer">
        &copy; {{ copyrightYears }} LYcoding 版权所有 | <a href="https://beian.miit.gov.cn">苏ICP备2024094389号-2</a>
    </div>
</template>

<script>
export default {
    computed: {
        copyrightYears() {
            const startYear = 2024;
            const currentYear = new Date().getFullYear();
            return currentYear > startYear ? `${startYear}-${currentYear}` : `${startYear}`;
        },
    },
};
</script>

<style scoped>
.footer {
    text-align: center;
    font-size: 12px;
    color: var(--app-muted);
    background: var(--app-surface);
    border-top: 1px solid var(--app-border);
    backdrop-filter: blur(14px);
    padding: 8px 12px;
}

.footer a {
    color: var(--app-muted);
    text-decoration: none;
}

.footer a:hover {
    color: var(--app-primary);
}
</style>
